/*
  * Copyright Amazon.com, Inc. and its affiliates. All Rights Reserved.
  * SPDX-License-Identifier: MIT
  *
  * Licensed under the MIT License. See the LICENSE accompanying this file
  * for the specific language governing permissions and limitations under
  * the License.
  */

import React from 'react';
import { connect } from 'react-redux';
import { setLang, setQueryParameters } from './redux/actions';

import { I18n } from '@aws-amplify/core';

/*
 * Load Branded Theme
 */
import { MuiThemeProvider } from '@material-ui/core/styles';
import { theme } from './branding'

/*
 * Load LandingPage for SingIn/SingUp
 */
import LandingPage from './components/LandingPage/LandingPage';

/*
 * Load i18n Localization
 */
import i18nStrings from './i18n/i18n';
import { getCookie } from './components/LandingPage/helpers/cookieHelper';
import isValidSession from './components/LandingPage/helpers/isValidSession';
import { Auth } from 'aws-amplify';
I18n.putVocabularies(i18nStrings);

/*
 *  Load Default Language
 * Check Browser Language: If it exists in i18n then use the Browser Language, else use default "en"
 */
const loadDefaultLanguage = () => {
	const navLang = navigator.language.substr(0, 2);
	if (i18nStrings.hasOwnProperty(navLang))
		return navLang;

	return "it"
}

/*
 * Map lang state to p
 */
const mapStateToProps = (state) => {
	return {
		lang: state.app.lang,
	}
}

class App extends React.Component {
	constructor(props) {
		super(props);

		this.props.setLang(loadDefaultLanguage());
		this.props.setQueryParameters(window.location.search)
		this.state = {};
	}

	componentDidMount(){
		window.addEventListener('message', async function(event) {
			const validDomains = [
				//Production
				"tecnichenuove.com",
				"tecnichenuove.it",
				//Wordpress Websites Staging
				"diemmea.com",
				//Frontend Sandbox
				"staging.d25xh7xk1y8mso.amplifyapp.com",
				"sso.d25xh7xk1y8mso.amplifyapp.com"]
				.concat(process.env.NODE_ENV === 'development' ? 
					['localhost:3000','test1.sso.local', 'test1.sso.local','b6af-78-209-204-73.ngrok-free.app'] : [])

			if(event?.data?.action && validDomains.map((domain)=>{ return event.origin.search(new RegExp(String.raw`${domain}$`, "g"))}).filter(found => found>=0).length){
					let idToken;
					console.log(`[SSO] Received handling action: ${event?.data?.action}`)

					try {
						const session = await Auth.currentSession();
						console.log({session})
						idToken = session.getIdToken().getJwtToken()
					} catch (error) {
						//Silent check and fallback on cookie
						console.log(`error currentSession:`,error)
						idToken = getCookie("id_token");
					}
				

					if(event?.data?.action === "autologin" && idToken){
						console.log(`[SSO] sending token to client...`)
						event.source.postMessage({
							action: `autologin`,
							idToken
						}, event.origin);
					}else if(event?.data?.action === "verify_login_session"){
						const session_is_valid = await isValidSession();
						console.log(`[SSO] sending session_is_valid:${session_is_valid}`)
						console.log(`Cookies__App: ${document.cookie}`)

						event.source.postMessage({
							action: `verify_login_session`,
							session_is_valid
						}, event.origin);
					}
					
				;
			}
		});
	}

	render() {
		return (
			<div>
				<MuiThemeProvider theme={theme}>
					<LandingPage />
				</MuiThemeProvider>
			</div>
		);
	}
}

export default connect(mapStateToProps, { setLang, setQueryParameters })(App);
